import { gql } from "@apollo/client";

export const createTier = gql`
  mutation CreateTier($input: TierInput!) {
    createTier(input: $input) {
      id
      name
      programId
      entryThresholdMinor
      multiplier
      benefits
      requirements
      tierRevision
      createdAt
      updatedAt
      createdBy
      updatedBy
      deletedAt
      deletedBy
    }
  }
`;
